import ColumnContainer from '@ulta/core/components/ColumnContainer/ColumnContainer';

export default ColumnContainer;